import React, { useState } from "react";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Box,
    Checkbox,
    TablePagination,
} from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ActionIconItem } from "../../../../components/others/ActionIconItem";
import { MOCKCONFIG } from '../../constants/interface.constants';

export const PreviewTable = ({ columns = [], fullJson = [], rowActions = [], handleToggleFullscreenPreviewEditor }) => {
    const fallbackColumns = columns.length ? columns : MOCKCONFIG.table; 
    const visibleColumns = fallbackColumns.filter((col) => col.visible);
    const [ pagination, setPagination ] = useState({ pageNumber: 1, pageSize: 25, });

    const handleChangePage = (event, newPage) => setPagination((prev) => ({ ...prev, pageNumber: newPage + 1 }));
    const handleChangeRowsPerPage = (event) => setPagination({ pageNumber: 1, pageSize: parseInt(event.target.value, 10)});
    const lineActions = rowActions.length ? rowActions : MOCKCONFIG.button;
    const mockRows = Array.from({ length: 5 }).map((_, i) => {
        const row = { id: i };
        visibleColumns.forEach((col) => row[col.id] = `Value ${i + 1} `);
        row.id = i + 1;
        return row;
    });

    return (
        <Box sx={ { width: "100%", mt:0} }>
            <Paper
                elevation={ 3 }
                sx={ {
                    width: "100%",
                    boxShadow: (theme) =>
                        theme.palette.mode === "dark"
                            ? "0px 0px 8px 0px rgba(0,0,0,0.75)"
                            : "0px 0px 8px 0px rgba(0,0,0,0.25)",
                    bgcolor: (theme) => theme.palette.background.paper,
                } }
            >
                <TableContainer
                    sx={ { maxHeight: 400, overflow: "auto", borderBottom: "solid 1px" } }
                >
                    <Table aria-labelledby="previewTable" size="small" stickyHeader>
                        <TableHead>
                            <TableRow>

                                <TableCell
                                    sx={ {
                                        minWidth: 40,
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 1000,
                                    } }
                                >
                                    <Checkbox
                                        disabled
                                        icon={ <RadioButtonUncheckedIcon fontSize="medium" /> }
                                        checkedIcon={ <CheckCircleIcon fontSize="medium" /> }
                                        color="primary"
                                    />
                                </TableCell>

                                <TableCell
                                    padding="normal"
                                    align="center"
                                    sx={ {
                                        minWidth: 120,
                                        position: "sticky",
                                        left: 52,
                                        zIndex: 1000,
                                        top: "-1px",
                                    } }
                                >
                                    <Typography sx={ { fontWeight: "bold" } } component="span">
                                        Actions
                                    </Typography>
                                </TableCell>

                                {/* Dynamic columns */ }
                                { visibleColumns.map((col, index) => (
                                    <TableCell
                                        key={ `th-${index}` }
                                        padding="normal"
                                        align="center"
                                        sx={ {
                                            width: col?.width ? `${col.width}px` : "auto",
                                            minWidth: col?.width ? `${col.width}px` : "auto",
                                            maxWidth: col?.width ? `${col.width}px` : "auto",
                                        } }
                                    >
                                        <Typography sx={ { fontWeight: "bold" } } component="span">
                                            { col.label }
                                        </Typography>
                                    </TableCell>
                                )) }
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            { mockRows.map((row) => (
                                <TableRow tabIndex={ -1 } key={ row.id }>
                                    {/* Sticky checkbox cell */ }
                                    <TableCell
                                        sx={ { position: "sticky", left: 0, bgcolor: "background.paper" } }
                                    >
                                        <Checkbox
                                            disabled
                                            icon={ <RadioButtonUncheckedIcon fontSize="medium" /> }
                                            checkedIcon={ <CheckCircleIcon fontSize="medium" /> }
                                            color="primary"
                                            sx={ { justifyContent: "center" } }
                                        />
                                    </TableCell>

                                    {/* Sticky actions cell */ }
                                    <TableCell
                                        padding="normal"
                                        align="center"
                                        sx={ { position: "sticky", left: 52, bgcolor: "background.paper" } }
                                    >
                                        <Box sx={ { display: 'flex', gap: 1, justifyContent: 'center' } }>
                                            {lineActions.map((action, idx) => (
                                                <ActionIconItem
                                                    key={idx}
                                                    item={action}
                                                    onClick={() => handleToggleFullscreenPreviewEditor(action, idx, 'row')}
                                                />
                                            ))}
                                        </Box>
                                    </TableCell>

                                    {/* Dynamic data cells */ }
                                    {visibleColumns.map((col, index) => (
                                        <TableCell
                                            key={ `td-${index}` }
                                            padding="normal"
                                            align={ col?.align || "center" }
                                        >
                                            <Typography>{ row[ col.id ] }</Typography>
                                        </TableCell>
                                    )) }
                                </TableRow>
                            )) }
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    sx={ { display: 'table-row', verticalAlign: 'bottom' } }
                    rowsPerPageOptions={ [ 25, 50, 100 ] }
                    component="Box"
                    count={ mockRows.length * 3 }
                    rowsPerPage={ pagination.pageSize }
                    page={ pagination.pageNumber - 1 }
                    onPageChange={ handleChangePage }
                    onRowsPerPageChange={ handleChangeRowsPerPage }
                />
            </Paper>
        </Box>
    );
};